import { useCallback, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Button, Code, Flex, Spinner, Text } from "@radix-ui/themes";
import { yotpoCases } from "./yotpoCases.data";

type YotpoCase = "case_1" | "case_2";

export function YotpoCases() {
  const [selectedCase, setSelectedCase] = useState<YotpoCase | null>(null);
  const [loading, setLoading] = useState(false);

  const identify = useCallback((prechatData: Record<string, any>) => {
    window.quack.identify({
      id: uuidv4(),
      email: "test@email.com",
      ...prechatData,
    });
  }, []);

  const handleCaseSelection = useCallback(
    (caseId: YotpoCase) => {
      setLoading(true);
      setSelectedCase(caseId);

      setTimeout(() => {
        identify(yotpoCases[caseId]);

        setTimeout(() => {
          setLoading(false);
        }, 3_000);
      }, 2_000);

      setTimeout(() => {
        setLoading(false);
      }, 6_000);
    },
    [identify]
  );

  return (
    <Flex direction={"column"} gap={"2"} align={"center"}>
      {selectedCase == null || loading ? (
        <>
          <Text size={"2"} color={"gray"}>
            Choose case before open chat
          </Text>

          {loading ? (
            <Spinner />
          ) : (
            <Flex gap={"2"}>
              <Button
                variant={"outline"}
                color={"gray"}
                onClick={() => handleCaseSelection("case_1")}
              >
                Case #1
                <Code>Is Free = false</Code>
              </Button>

              <Button
                variant={"outline"}
                color={"gray"}
                onClick={() => handleCaseSelection("case_2")}
              >
                Case #2
                <Code>Is Free = true</Code>
              </Button>
            </Flex>
          )}
        </>
      ) : (
        <>
          <Text size={"2"} color={"gray"}>
            Now open chat
          </Text>

          <Text size={"2"} color={"gray"}>
            {selectedCase === "case_1" ? "Case #1 " : "Case #2 "}
            <Code>{`Is Free = ${
              selectedCase === "case_1" ? "false" : "true"
            }`}</Code>
          </Text>
        </>
      )}
    </Flex>
  );
}
